export * from './constant-analystic';

export * from './upsell-popup-constant';

export * from './upsell-bundle-constant';

export * from './design-settings-constant';

export const UPGRADE_PLAN_PACKAGE = 'UPGRADE_PLAN_PACKAGE';
export const GET_PRICING_PLAN = 'GET_PRICING_PLAN';
export const GET_PRICING_PLAN_RESULT = 'GET_PRICING_PLAN_RESULT';
export const CHANGE_APP_STATUS = 'CHANGE_APP_STATUS';
export const CHANGE_APP_STATUS_RESULT = 'CHANGE_APP_STATUS_RESULT';
export const RESET_CHANGE_STATUS_APP_RESULT = 'RESET_CHANGE_STATUS_APP_RESULT';
export const GET_LIST_CAMPAIGN_ALL = 'GET_LIST_CAMPAIGN_ALL';
export const GET_LIST_CAMPAIGN_ALL_RESULT = 'GET_LIST_CAMPAIGN_ALL_RESULT';
export const CHANGE_STATUS_UPSELL_CAMPAIGN = 'CHANGE_STATUS_UPSELL_CAMPAIGN';
export const CHANGE_STATUS_UPSELL_CAMPAIGN_RESULT = 'CHANGE_STATUS_UPSELL_CAMPAIGN_RESULT';
export const DELETE_UPSELL_CAMPAIGN = 'DELETE_UPSELL_CAMPAIGN';
export const DELETE_UPSELL_CAMPAIGN_RESULT = 'DELETE_UPSELL_CAMPAIGN_RESULT';
export const CHANGE_APP_REDUCER_FIELD = 'CHANGE_APP_REDUCER_FIELD';

export const CHANGE_THEME_EVEN_POPUP = 'CHANGE_THEME_EVEN_POPUP';
export const GET_LIST_NOTIFICATION = 'GET_LIST_NOTIFICATION';
export const GET_LIST_NOTIFICATION_RESULT = 'GET_LIST_NOTIFICATION_RESULT';
export const GET_NOTIFICATION_DETAIL = 'GET_NOTIFICATION_DETAIL';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const UPDATE_NOTIFICATION_RESULT = 'UPDATE_NOTIFICATION_RESULT';
export const GET_NOTIFICATION_DETAIL_RESULT = 'GET_NOTIFICATION_DETAIL_RESULT';
export const GET_SHOP_INFO = 'GET_SHOP_INFO';
export const GET_SHOP_INFO_RESPONSE = 'GET_SHOP_INFO_RESPONSE';
export const GET_CURRENCY_SHOP = 'GET_CURRENCY_SHOP'; // Lấy định dạng tiền tệ của shop
export const GET_CURRENCY_SHOP_RESPONSE = 'GET_CURRENCY_SHOP_RESPONSE';

export const CHANGE_SAVER_BAR_SETTINGS_FIELD = 'CHANGE_SAVER_BAR_SETTINGS_FIELD';
export const GET_GLOBAL_SETTING = 'GET_GLOBAL_SETTING';
export const GET_GLOBAL_SETTING_RESULT = 'GET_GLOBAL_SETTING_RESULT';
export const GET_COUNT_VIEW = 'GET_COUNT_VIEW';
export const GET_COUNT_VIEW_RESULT = 'GET_COUNT_VIEW_RESULT';
export const GET_STATISTIC_CHART = 'GET_STATISTIC_CHART';
export const GET_STATISTIC_CHART_RESULT = 'GET_STATISTIC_CHART_RESULT';
export const GET_VIEW_BY_PLAN = 'GET_VIEW_BY_PLAN';
export const GET_VIEW_BY_PLAN_RESULT = 'GET_VIEW_BY_PLAN_RESULT';
